import es from "./es";
import en from "./en";
import ca from "./ca";
import fr from "./fr";
import de from "./de";
import it from "./it";
import zh from "./zh";
import ja from "./ja";

export const STRINGS = { es, en, ca, fr, de, it, zh, ja };
